module.exports = __webpack_public_path__ + "img/Truck-Camper-Mobile.3bb5be8c.jpg";